import React, { useCallback, useEffect, useState } from 'react';
// import { IResolveParams, LoginSocialGoogle, LoginSocialMicrosoft, TypeCrossFunction } from 'reactjs-social-login';
//import { useLinkedIn } from 'react-linkedin-login-oauth2';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { ReduxCandidateListType, setReduxProfile } from '../../redux/registration';
import { SocialEnum, SocialEnumKeyType } from '../../types/auth';
import { authService } from '../../lib/api/auth';
import { registrationLocationConstants } from '../../lib/constants/constants';
import { digioKYCUrl } from '../../config/constants';
import { routes } from '../routes/routes-names';
import { Message, SweetAlertTitle, WarningIcon } from '../../lib/constants/messages';
import { authType } from '../../lib/auth-type';
import microsoftLogo from '../../assets/img/Microsoft.png';
import googleLogo from '../../assets/img/Google.png';
import { history } from '../../history';
import queryString from 'query-string';
import Swal from 'sweetalert2';
import { useKYCDigioSignFlow } from '../../hooks/useSelector';
import { sessionStorageClearAll, sessionStorageSetItem } from '../../components/storage/sessionStorageManager';
import { localStorageGetItem, localStorageSetItem } from '../../components/storage/localStorageManager';
import NewRegOTP from '../../components/otp/newRegOTP';
import { OTPType } from '../../types/userOtp';
import { KYCdigioSign } from '../../lib/utils/digio-kyc-sign';
import { getKYCRequestIdAndToken } from '../../lib/api/digioKYC';
import { isKYCDigioSignFeatureEnabled } from '../../lib/utils/common-functions';
import { useScript } from '../../hooks/script';
import { getKYCDigioSignSettings } from '../../redux/KYCDigioSign';
import GoogleLoginComponent from './google-login';
import { MicrosoftLoginComponent } from './microsoft-login';
import { useAppDispatch } from '../../redux/reduxhooks';

type AuthSocialProps = {
    goToRegistration: () => void;
    handleSelect: (key: string, key2: string, value: any) => void;
    setShowSelectAccountType: (key: boolean) => void;
    setDigioSuccessData?: (key: any) => void;
    candidateType: string;
    disableButton: boolean;
    setPageLoading: (key: boolean) => void;
    setAuthType: (key: string) => void;
    setActiveTab?: (key: string) => void;
    setShowPasswordTab?: (key: boolean) => void;
};

const CommanTab: React.FC<AuthSocialProps> = ({
    goToRegistration,
    setDigioSuccessData,
    candidateType,
    handleSelect,
    setShowSelectAccountType,
    disableButton,
    setPageLoading,
    setAuthType,
    setShowPasswordTab,
    setActiveTab,
}) => {
    // const googleRef = useRef<TypeCrossFunction>(null!);
    const dispatch = useAppDispatch();
    // const microsoftRef = useRef<TypeCrossFunction>(null!);
    const [loading, setLoading] = useState('');
    const [unclaimedCompanyLocalData, setUnclaimedCompanyLocalData] = useState('');

    const location = history.location;

    const { ConfirmCandidateInvitationId, ConfirmManagerInvitationId } = queryString.parse(location.search);

    // const ssoUserProfile = useUserProfile();

    const digioKYCReady = useScript(digioKYCUrl);
    const kycDigioSignFlowSettings = useKYCDigioSignFlow();

    useEffect(() => {
        setTimeout(() => {
            sessionStorageSetItem(
                'invitationId',
                ConfirmCandidateInvitationId || ConfirmManagerInvitationId || null,
                false
            );
        }, 300);
    }, [ConfirmCandidateInvitationId, ConfirmManagerInvitationId]);

    const handleKYCSuccess = (response: any) => {
        setDigioSuccessData?.(response);
        setTimeout(() => {
            handleSelect('basic-details', candidateType, {});
            setShowSelectAccountType(false);
            setPageLoading(false);
        }, 1000);
    };

    const handleKYCFailure = (response: any) => {
        setPageLoading(false);
    };

    const fetchKYCRequestToken = async (customEmail: string) => {
        const { requestId, accessToken } = await getKYCRequestIdAndToken(customEmail);
        if (requestId && accessToken) {
            KYCdigioSign(requestId, customEmail, accessToken, handleKYCSuccess, handleKYCFailure);

            localStorageSetItem('requestId', requestId);
        }
    };

    const signIn = useCallback(
        // async (provider: SocialEnumKeyType, profile) => {
        async (provider: SocialEnumKeyType, profile: any) => {
            const email = getEmail(provider, profile);
            localStorageSetItem('Email', email);
            localStorageSetItem('unclaimed', unclaimedCompanyLocalData, false);

            try {
                setLoading(provider);
                setPageLoading(true);

                // let emailDomain = getEmailDomainWithDot(email as string);
                // let isPersonalAcount = personalAccountDomains.includes(emailDomain);

                // if (candidateType === 'Company' && isPersonalAcount) {
                //     setLoading('');
                //     return Swal.fire({
                //         title: 'Sorry',
                //         text: 'Personal accounts are not allowed for an employer registration.',
                //         icon: 'error',
                //         confirmButtonText: 'Ok',
                //     });
                // }

                const data = await authService.socialSignIn({
                    Email: email,
                    AuthType: SocialEnum[provider],
                    Token: profile.id_token,
                    Location: registrationLocationConstants.IsRegistration,
                });

                if (data) {
                    authType.setAuthType(provider);
                }

                setPageLoading(false);
            } catch (err: any) {
                if (err.response.status === 400) {
                    setPageLoading(true);
                    if (err.response.data.error.message === Message.UserExists) {
                        Swal.fire({
                            title: SweetAlertTitle.Sorry,
                            text: Message.EmailAlreadyRegistered,
                            icon: WarningIcon,
                            confirmButtonText: 'Ok',
                        });
                        setLoading('');
                        setPageLoading(false);
                    }
                } else if (err.response.status === 401) {
                    setPageLoading(true);
                    setLoading('');
                    if (candidateType === 'candidate') {
                        if (isKYCDigioSignFeatureEnabled(kycDigioSignFlowSettings) && digioKYCReady && email) {
                            fetchKYCRequestToken(email);
                        } else {
                            handleSelect('basic-details', candidateType, email);
                            setShowSelectAccountType(false);
                            setPageLoading(false);
                        }

                        const fullName = getFullName(provider, profile);
                        const profileSocial: ReduxCandidateListType = {
                            ...fullName,
                            email,
                            token: profile.id_token,
                            authType: SocialEnum[provider],
                        };
                        dispatch(setReduxProfile(profileSocial));
                    } else if (candidateType === 'company') {
                        handleSelect('basic-details', 'company', email);
                        setShowSelectAccountType(false);

                        const fullName = getFullName(provider, profile);
                        const profileSocial: ReduxCandidateListType = {
                            ...fullName,
                            email,
                            token: profile.id_token,
                            authType: SocialEnum[provider],
                        };
                        dispatch(setReduxProfile(profileSocial));
                    }
                    setPageLoading(false);
                } else {
                    toast.error(Message.AuthenticationError);
                    setLoading('');
                }
            }
        },
        [setPageLoading, candidateType, kycDigioSignFlowSettings, digioKYCReady, dispatch]
    );

    useEffect(() => {
        sessionStorageClearAll();

        const storageData = localStorageGetItem('unclaimed', false)!;

        if (storageData) {
            setUnclaimedCompanyLocalData({ ...storageData, claimedType: 'company' });
        }
    }, [ConfirmCandidateInvitationId, ConfirmManagerInvitationId]);

    useEffect(() => {
        if (!kycDigioSignFlowSettings?.settings) dispatch(getKYCDigioSignSettings());
        // localStorageRemoveItem('claimedType');
    }, []);

    return (
        <>
            {/* <div className="w-100 text-center mb-3">
                <h1 className="fs-18 mb-3">Please do a social login for a hassle-free sign-up process</h1>
            </div> */}
            <div className="w-100 mb-4">
                <h1 className="fs-32 fw-600 text-center mb-4">
                    Create Account and <br /> Try OfferX for free
                </h1>
                {/* <div className="fs-16 lt-text-secondary">Select Your Option And Sign Up Today!</div> */}
            </div>

            {/* <button
                className="btn btn-outline-primary outline-p-hover w-100 h-44"
                onClick={() => {
                    handleSelect('account-details', '', '');
                    // setShowSelectAccountType(false);
                    setAuthType('customAuth');
                }}
            >
                <i className="bi bi-envelope-fill"></i> Create Account
            </button> */}
            {/* <div className="d-block justify-content-between social-btns mb-4 pointer-events-none"> */}
            <div className="d-block justify-content-between social-btns mb-4 ">
                <div className="text-center mb-3">
                    {disableButton ? (
                        <button type="button" className="btn login-btn microsoft-btn text-center w-100" disabled>
                            <span className="microsoft-icon">
                                <img loading='lazy'src={googleLogo} width={20} alt="Google logo" />
                            </span>
                            <span className="social-btn-text">Sign up with Google</span>
                        </button>
                    ) : loading === 'microsoft' ? (
                        <>
                            {' '}
                            <div className="new-spinner p-absolute">
                                <div>
                                    <span className="spinner-border spinner-border-sm custom-spinner-border" />
                                </div>
                                <p className="fs-14 custom-loading-text">Loading</p>
                            </div>
                            {/* <LoginSocialGoogle
                                // ref={googleRef}
                                client_id={googleClientId}
                                onResolve={({ provider, data }: IResolveParams) => {
                                    if (provider === 'google') {
                                        signIn(provider, data);
                                    }
                                }}
                                onReject={(err) => {}}
                            >
                                <button
                                    type="button"
                                    className="btn login-btn google-btn pointer-events-all text-center w-100"
                                >
                                    <span className="google-icon">
                                        <img loading='lazy'src={googleLogo} width={20} alt="Google logo" />
                                    </span>
                                    <span className="google-text-margin social-btn-text">Sign up with Google</span>
                                </button>
                            </LoginSocialGoogle> */}
                            <GoogleLoginComponent signIn={signIn} label="Sign up with Google" />
                        </>
                    ) : (
                        // <LoginSocialGoogle
                        //     // ref={googleRef}
                        //     client_id={googleClientId}
                        //     onResolve={({ provider, data }: IResolveParams) => {
                        //         if (provider === 'google') {
                        //             signIn(provider, data);
                        //         }
                        //     }}
                        //     onReject={(err) => {}}
                        // >
                        //     <button
                        //         type="button"
                        //         className="btn login-btn google-btn pointer-events-all text-center w-100"
                        //     >
                        //         <span className="google-icon">
                        //             <img loading='lazy'src={googleLogo} width={20} alt="Google logo" />
                        //         </span>
                        //         <span className="google-text-margin social-btn-text">Sign up with Google</span>
                        //     </button>
                        // </LoginSocialGoogle>
                        <>
                            <GoogleLoginComponent signIn={signIn} label="Sign up with Google" />
                        </>
                    )}
                </div>
                <div className="text-center">
                    {disableButton ? (
                        <button type="button" className="btn login-btn microsoft-btn text-center w-100" disabled>
                            <span className="microsoft-icon">
                                <img loading='lazy'src={microsoftLogo} width={20} alt="Microsoft logo" />
                            </span>
                            <span className="social-btn-text">Sign up with Microsoft</span>
                        </button>
                    ) : loading === 'microsoft' ? (
                        <>
                            {' '}
                            <div className="new-spinner p-absolute">
                                <div>
                                    <span className="spinner-border spinner-border-sm custom-spinner-border" />
                                </div>
                                <p className="fs-14 custom-loading-text">Loading</p>
                            </div>
                            {/* <LoginSocialMicrosoft
                                // ref={microsoftRef}
                                client_id={microsoftClientId}
                                redirect_uri={window.location.origin}
                                onResolve={({ provider, data }: IResolveParams) => {
                                    if (provider === 'microsoft') {
                                        signIn(provider, data);
                                    }
                                }}
                                onReject={(err) => {}}
                                scope="profile openid email User.Read"
                            >
                                <button
                                    type="button"
                                    className="btn login-btn microsoft-btn pointer-events-all text-center w-100"
                                >
                                    <span className="microsoft-icon">
                                        <img loading='lazy'src={microsoftLogo} width={20} alt="Microsoft logo" />
                                    </span>
                                    <span className="social-btn-text">Sign up with Microsoft</span>
                                </button>
                            </LoginSocialMicrosoft> */}
                            <MicrosoftLoginComponent signIn={signIn} label="Sign up with Microsoft" />
                        </>
                    ) : (
                        // <LoginSocialMicrosoft
                        //     // ref={microsoftRef}
                        //     client_id={microsoftClientId}
                        //     redirect_uri={window.location.origin}
                        //     onResolve={({ provider, data }: IResolveParams) => {
                        //         if (provider === 'microsoft') {
                        //             signIn(provider, data);
                        //         }
                        //     }}
                        //     onReject={(err) => {}}
                        //     scope="profile openid email User.Read"
                        // >
                        //     <button
                        //         type="button"
                        //         className="btn login-btn microsoft-btn pointer-events-all text-center w-100"
                        //     >
                        //         <span className="microsoft-icon">
                        //             <img loading='lazy'src={microsoftLogo} width={20} alt="Microsoft logo" />
                        //         </span>
                        //         <span className="social-btn-text">Sign up with Microsoft</span>
                        //     </button>
                        // </LoginSocialMicrosoft>
                        <MicrosoftLoginComponent signIn={signIn} label="Sign up with Microsoft" />
                    )}
                </div>
                {/* <div className="mx-3">
                {loading === 'linkedIn' ? (
                    <button type="button" className="btn btn-info login-btn linkedin-btn" disabled>
                        <span className="linkedin-icon">
                            <span className="spinner-border spinner-border-sm" />
                        </span>{' '}
                        LinkedIn
                    </button>
                ) : (
                    <button
                        type="button"
                        onClick={linkedInLogin}
                        className="btn btn-info login-btn linkedin-btn"
                    >
                        <span className="linkedin-icon">
                            <i className="bi bi-linkedin" />
                        </span>{' '}
                        LinkedIn
                    </button>
                )}
            </div> */}
            </div>
            <div className="social-or-line my-3">or</div>
            <div>
                <div className="fs-14 fw-400 mb-3 text-center lt-text-secondary">
                    If you have any other email apart from
                    <br />
                    Google and Microsoft
                </div>
                <NewRegOTP
                    otpType={OTPType.Registration}
                    emailLabel="Email"
                    emailPlaceholder="Enter Email"
                    candidateType={candidateType}
                    setAuthType={setAuthType}
                    setShowPasswordTab={setShowPasswordTab}
                    setActiveTab={setActiveTab}
                />
            </div>
            {/* <div className="w-100 m-auto fs-14 lt-text-secondary">
                By clicking sign up or create account, you agree to the OfferX <br />{' '}
                <a className="text-decoration-underline lt-text-primary-alt" target="_blank" href="/legal/terms">
                    Terms &amp; Conditions
                </a>
                ,{' '}
                <a className="text-decoration-underline lt-text-primary-alt" target="_blank" href="/legal/privacy">
                    Privacy
                </a>{' '}
                and{' '}
                <a
                    className="text-decoration-underline lt-text-primary-alt"
                    target="_blank"
                    href="/legal/privacy#Item-6"
                >
                    Cookie policies.
                </a>
            </div> */}
            <div className="my-3 text-m-center">
                <p className="fs-14 lt-text-secondary text-center">
                    Already have an account?
                    <Link to={routes.signinSignup}>
                        <a className="lt-text-primary-alt cursor-pointer"> Log In</a>
                    </Link>
                </p>
            </div>

            {/* {ConfirmCandidateInvitationId || ConfirmManagerInvitationId ? (
                <></>
            ) : (
                <div className="d-flex justify-content-center">
                    <button
                        onClick={() => {
                            setShowSelectAccountType(true);
                        }}
                        className="btn btn-primary social-next-button"
                    >
                        Back
                    </button>
                </div>
            )} */}
        </>
    );
};

export default CommanTab;

function getEmail(provider: SocialEnumKeyType, profile: any) {
    return SocialEnum[provider] === SocialEnum.microsoft
        ? profile?.email ||
              profile?.username ||
              profile?.idTokenClaims?.email ||
              profile?.idTokenClaims?.preferred_username
        : SocialEnum[provider] === SocialEnum.google
        ? profile?.email
        : SocialEnum[provider] === SocialEnum.linkedIn
        ? profile?.emailAddress
        : '';
}

function getFullName(provider: SocialEnumKeyType, profile: any) {
    return SocialEnum[provider] === SocialEnum.google || SocialEnum[provider] === SocialEnum.linkedIn
        ? {
              firstName: profile.name?.split(' ')[0] || '',
              lastName: profile.name?.split(' ').slice(1).join(' ') || '',
          }
        : SocialEnum[provider] === SocialEnum.microsoft
        ? {
              firstName: profile?.name?.split(' ')[0] || '',
              lastName: profile?.name?.split(' ').slice(1).join(' ') || '',
          }
        : { firstName: '', lastName: '' };
}
